// src/pages/ServicePage.jsx
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import '../../styles/Services-css/ServicePage.css';
import logo_0 from "../../../assets/images/R2R.png";

// Mock data for demonstration purposes
const initialServices = [
    { 
        id: 1, 
        name: 'Home Deep Cleaning', 
        provider: 'CleanPro Services', 
        image: 'https://placehold.co/600x400?text=Cleaning', 
        rating: 4.8, 
        reviews: 1250, 
        price: 499, 
        category: 'Cleaning',
        description: 'Professional deep cleaning service for your entire home' 
    },
    { 
        id: 2, 
        name: 'Professional Plumbing', 
        provider: 'FixIt Experts', 
        image: 'https://placehold.co/600x400?text=Plumbing', 
        rating: 4.7, 
        reviews: 890, 
        price: 299, 
        category: 'Repairs',
        description: 'Expert plumbing solutions for all your needs' 
    },
    { 
        id: 3, 
        name: 'Beauty & Spa at Home', 
        provider: 'Glow Beauty', 
        image: 'https://placehold.co/600x400?text=Beauty', 
        rating: 4.9, 
        reviews: 2100, 
        price: 599, 
        category: 'Beauty',
        description: 'Relaxing spa and beauty treatments at your home' 
    },
    { 
        id: 4, 
        name: 'Electrical Repair Service', 
        provider: 'PowerFix Solutions', 
        image: 'https://placehold.co/600x400?text=Electrical', 
        rating: 4.6, 
        reviews: 750, 
        price: 199, 
        category: 'Repairs',
        description: 'Safe and reliable electrical repair services' 
    },
    { 
        id: 5, 
        name: 'Interior Wall Painting', 
        provider: 'ColorWays', 
        image: 'https://placehold.co/600x400?text=Painting', 
        rating: 4.8, 
        reviews: 1500, 
        price: 2500, 
        category: 'Painting',
        description: 'Professional interior wall painting services' 
    },
];

const defaultCategories = ['Cleaning', 'Repairs', 'Beauty', 'Painting'];
const ratings = [4, 3, 2, 1];

// Cart Component
const Cart = ({ cartItems, onRemoveItem, onUpdateQuantity, onViewCart }) => {
    const totalSavings = cartItems.reduce((total, item) => total + ((item.originalPrice - item.price) * item.quantity), 0);
    const subtotal = cartItems.reduce((total, item) => total + (item.price * item.quantity), 0);

    if (cartItems.length === 0) {
        return (
            <div className="cart-sidebar">
                <div className="cart-header">
                    <h3>Cart</h3>
                </div>
                <div className="empty-cart">
                    <p>No items in your cart</p>
                </div>
                <div className="cart-promo">
                    <div className="save-banner">
                        <strong>Save 10% on every order</strong>
                        <button className="plus-btn">Get Plus now</button>
                    </div>
                    <button className="view-offers-btn">View More Offers</button>
                </div>
                <div className="uc-promise">
                    <h4>UC Promise</h4>
                    <ul>
                        <li>✓ Verified Professionals</li>
                        <li>✓ Hassle Free Booking</li>
                        <li>✓ Transparent Pricing</li>
                    </ul>
                </div>
            </div>
        );
    }

    return (
        <div className="cart-sidebar">
            <div className="cart-header">
                <h3>Cart</h3>
            </div>
            
            <div className="cart-items">
                {cartItems.map(item => (
                    <div key={item.id} className="cart-item">
                        <div className="cart-item-info">
                            <h4>{item.name}</h4>
                            <p className="cart-item-desc">{item.description}</p>
                            <div className="cart-item-controls">
                                <button 
                                    onClick={() => onUpdateQuantity(item.id, item.quantity - 1)}
                                    disabled={item.quantity <= 1}
                                    className="quantity-btn"
                                    aria-label={`Decrease quantity of ${item.name}`}
                                >
                                    -
                                </button>
                                <span className="quantity">{item.quantity}</span>
                                <button 
                                    onClick={() => onUpdateQuantity(item.id, item.quantity + 1)}
                                    className="quantity-btn"
                                    aria-label={`Increase quantity of ${item.name}`}
                                >
                                    +
                                </button>
                                <button 
                                    onClick={() => onRemoveItem(item.id)}
                                    className="remove-btn"
                                    aria-label={`Remove ${item.name} from cart`}
                                >
                                    Remove
                                </button>
                            </div>
                        </div>
                        <div className="cart-item-price">
                            <span className="price">₹{item.price * item.quantity}</span>
                            {item.originalPrice > item.price && (
                                <span className="original-price">₹{item.originalPrice * item.quantity}</span>
                            )}
                        </div>
                    </div>
                ))}
            </div>

            {totalSavings > 0 && (
                <div className="savings-banner">
                    <p>Congratulations! ₹{totalSavings} saved so far!</p>
                </div>
            )}

            <div className="cart-summary">
                <div className="subtotal">
                    <span>Subtotal</span>
                    <span>₹{subtotal}</span>
                </div>
                <button className="view-cart-btn" onClick={onViewCart}>
                    View Cart
                </button>
            </div>

            <div className="cart-promo">
                <div className="save-banner">
                    <strong>Save 10% on every order</strong>
                    <button className="plus-btn">Get Plus now</button>
                </div>
                <button className="view-offers-btn">View More Offers</button>
            </div>

            <div className="uc-promise">
                <h4>UC Promise</h4>
                <ul>
                    <li>✓ Verified Professionals</li>
                    <li>✓ Hassle Free Booking</li>
                    <li>✓ Transparent Pricing</li>
                </ul>
            </div>
        </div>
    );
};

export default function ServicePage({ 
  serviceName = "Professional Home Services",
  packages = [],
  miniServices = [],
  customServices = null,
  customCategories = null,
  isCustomService = false
}) {
    const navigate = useNavigate();
    const [services, setServices] = useState(customServices || initialServices);
    const [viewMode, setViewMode] = useState('grid');
    const [cartItems, setCartItems] = useState([]);
    
    // State for filters
    const [searchQuery, setSearchQuery] = useState('');
    const [selectedCategories, setSelectedCategories] = useState([]);
    const [price, setPrice] = useState(5000);
    const [selectedRating, setSelectedRating] = useState(0);
    const [sortBy, setSortBy] = useState('popular');

    const categories = customCategories || defaultCategories;

    const handleCategoryChange = (category) => {
        setSelectedCategories(prev =>
            prev.includes(category)
                ? prev.filter(c => c !== category)
                : [...prev, category]
        );
    };

    const addToCart = (service) => {
        setCartItems(prev => {
            const existingItem = prev.find(item => item.id === service.id);
            if (existingItem) {
                return prev.map(item =>
                    item.id === service.id
                        ? { ...item, quantity: item.quantity + 1 }
                        : item
                );
            } else {
                const cartItem = {
                    id: service.id,
                    name: service.name,
                    description: service.description || `${service.name} by ${service.provider}`,
                    price: service.price,
                    originalPrice: Math.round(service.price * 1.2), // 20% more for showing savings
                    quantity: 1,
                    image: service.image
                };
                return [...prev, cartItem];
            }
        });
    };

    const removeFromCart = (serviceId) => {
        setCartItems(prev => prev.filter(item => item.id !== serviceId));
    };

    const updateQuantity = (serviceId, newQuantity) => {
        if (newQuantity < 1) {
            removeFromCart(serviceId);
            return;
        }
        setCartItems(prev =>
            prev.map(item =>
                item.id === serviceId
                    ? { ...item, quantity: newQuantity }
                    : item
            )
        );
    };

    const handleViewCart = () => {
        if (cartItems.length === 0) {
            alert('Your cart is empty. Please add services before proceeding.');
            return;
        }
        
        navigate('/slot-booking', { 
            state: { 
                cartItems: cartItems 
            } 
        });
    };

    const filteredAndSortedServices = services
        .filter(service => {
            const matchesSearch = service.name.toLowerCase().includes(searchQuery.toLowerCase()) || 
                                service.provider.toLowerCase().includes(searchQuery.toLowerCase());
            const matchesCategory = selectedCategories.length === 0 || selectedCategories.includes(service.category);
            const matchesPrice = service.price <= price;
            const matchesRating = service.rating >= selectedRating;
            return matchesSearch && matchesCategory && matchesPrice && matchesRating;
        })
        .sort((a, b) => {
            switch (sortBy) {
                case 'rating': return b.rating - a.rating;
                case 'price-low': return a.price - b.price;
                case 'price-high': return b.price - a.price;
                case 'popular': default: return b.reviews - a.reviews;
            }
        });

    return (
        <div className="service-page-container">
            {/* Simple Header with Only Logo */}
            <header className="service-page-header">
                <div className="header-container">
                    <div className="logo-container">
                        <img src={logo_0} className="header-logo" alt="R2R Logo" />
                    </div>
                </div>
            </header>

            <div className="page-layout">
                <aside className="filters-sidebar">
                    <div className="sidebar-content">
                        <div className="filters-header">
                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                <polygon points="22 3 2 3 10 12.46 10 19 14 21 14 12.46 22 3"></polygon>
                            </svg>
                            <h3>Filters</h3>
                        </div>

                        <div className="filter-section">
                            <label htmlFor="search-services" className="filter-label">Search Services</label>
                            <div className="search-box">
                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="search-icon">
                                    <circle cx="11" cy="11" r="8"></circle>
                                    <path d="m21 21-4.3-4.3"></path>
                                </svg>
                                <input
                                    id="search-services"
                                    type="search"
                                    placeholder="Search by name or provider..."
                                    value={searchQuery}
                                    onChange={(e) => setSearchQuery(e.target.value)}
                                    className="filter-input"
                                />
                            </div>
                        </div>

                        <hr className="divider" />

                        <div className="filter-section">
                            <label className="filter-label">Categories</label>
                            <div className="checkbox-group">
                                {categories.map(category => (
                                    <div key={category} className="checkbox-item">
                                        <input 
                                            type="checkbox" 
                                            id={`cat-${category}`} 
                                            checked={selectedCategories.includes(category)} 
                                            onChange={() => handleCategoryChange(category)} 
                                        />
                                        <label htmlFor={`cat-${category}`}>{category}</label>
                                    </div>
                                ))}
                            </div>
                        </div>

                        <hr className="divider" />

                        <div className="filter-section">
                            <label htmlFor="price-range" className="filter-label">Price Range</label>
                            <div className="slider-container">
                                <input 
                                    id="price-range"
                                    type="range" 
                                    min="0" 
                                    max="5000" 
                                    value={price} 
                                    step="100" 
                                    onChange={(e) => setPrice(Number(e.target.value))} 
                                    className="price-slider" 
                                />
                                <div className="slider-labels">
                                    <span>₹0</span>
                                    <span>₹{price}</span>
                                </div>
                            </div>
                        </div>

                        <hr className="divider" />

                        <div className="filter-section">
                            <label className="filter-label">Minimum Rating</label>
                            <div className="radio-group">
                                <div className="radio-item">
                                    <input 
                                        type="radio" 
                                        id="rating-any" 
                                        name="rating" 
                                        value={0} 
                                        checked={selectedRating === 0} 
                                        onChange={(e) => setSelectedRating(Number(e.target.value))} 
                                    />
                                    <label htmlFor="rating-any">Any Rating</label>
                                </div>
                                {ratings.map(rating => (
                                    <div key={rating} className="radio-item">
                                        <input 
                                            type="radio" 
                                            id={`rating-${rating}`} 
                                            name="rating" 
                                            value={rating} 
                                            checked={selectedRating === rating} 
                                            onChange={(e) => setSelectedRating(Number(e.target.value))} 
                                        />
                                        <label htmlFor={`rating-${rating}`}>{rating} & up ⭐</label>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                </aside>

                <main className="main-content">
                    <div className="main-header">
                        <div className="header-title">
                            <h1>{serviceName}</h1>
                            <p>{filteredAndSortedServices.length} services available</p>
                        </div>
                        <div className="header-controls">
                            <select 
                                value={sortBy} 
                                onChange={(e) => setSortBy(e.target.value)} 
                                className="sort-select"
                                aria-label="Sort services by"
                            >
                                <option value="popular">Most Popular</option>
                                <option value="rating">Highest Rated</option>
                                <option value="price-low">Price: Low to High</option>
                                <option value="price-high">Price: High to Low</option>
                            </select>
                            
                            <div className="view-toggle">
                                <button 
                                    onClick={() => setViewMode('grid')} 
                                    className={`view-btn ${viewMode === 'grid' ? 'active' : ''}`}
                                    aria-label="Grid view"
                                    aria-pressed={viewMode === 'grid'}
                                >
                                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                        <rect width="7" height="7" x="3" y="3" rx="1"></rect>
                                        <rect width="7" height="7" x="14" y="3" rx="1"></rect>
                                        <rect width="7" height="7" x="14" y="14" rx="1"></rect>
                                        <rect width="7" height="7" x="3" y="14" rx="1"></rect>
                                    </svg>
                                </button>
                                <button 
                                    onClick={() => setViewMode('list')} 
                                    className={`view-btn ${viewMode === 'list' ? 'active' : ''}`}
                                    aria-label="List view"
                                    aria-pressed={viewMode === 'list'}
                                >
                                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                        <line x1="8" x2="21" y1="6" y2="6"></line>
                                        <line x1="8" x2="21" y1="12" y2="12"></line>
                                        <line x1="8" x2="21" y1="18" y2="18"></line>
                                        <line x1="3" x2="3.01" y1="6" y2="6"></line>
                                        <line x1="3" x2="3.01" y1="12" y2="12"></line>
                                        <line x1="3" x2="3.01" y1="18" y2="18"></line>
                                    </svg>
                                </button>
                            </div>
                        </div>
                    </div>

                    <div className={viewMode === 'grid' ? 'services-grid' : 'services-list'}>
                        {filteredAndSortedServices.length === 0 ? (
                            <div className="no-services-found">
                                <p>No services found matching your criteria.</p>
                            </div>
                        ) : (
                            filteredAndSortedServices.map(service => (
                                <div key={service.id} className="card">
                                    {viewMode === 'grid' ? (
                                        <>
                                            <img src={service.image} alt={`${service.name} service`} className="card-image-grid" />
                                            <div className="card-content">
                                                <p className="card-category">{service.category}</p>
                                                <h3 className="card-title">{service.name}</h3>
                                                <p className="card-provider">by {service.provider}</p>
                                                <div className="card-rating">
                                                    <span className="star-icon">⭐</span>
                                                    <span className="rating-value">{service.rating}</span>
                                                    <span className="review-count">({service.reviews} reviews)</span>
                                                </div>
                                                <div className="card-footer">
                                                    <p className="card-price">₹{service.price}</p>
                                                    <button 
                                                        className="add-to-cart-btn"
                                                        onClick={() => addToCart(service)}
                                                        aria-label={`Add ${service.name} to cart`}
                                                    >
                                                        Add to Cart
                                                    </button>
                                                </div>
                                            </div>
                                        </>
                                    ) : (
                                        <div className="list-view-content">
                                            <img src={service.image} alt={`${service.name} service`} className="card-image-list" />
                                            <div className="card-content">
                                                <p className="card-category">{service.category}</p>
                                                <h3 className="card-title">{service.name}</h3>
                                                <p className="card-provider">by {service.provider}</p>
                                                <div className="card-rating">
                                                    <span className="star-icon">⭐</span>
                                                    <span className="rating-value">{service.rating}</span>
                                                    <span className="review-count">({service.reviews} reviews)</span>
                                                </div>
                                                <div className="card-footer">
                                                    <p className="card-price">₹{service.price}</p>
                                                    <button 
                                                        className="add-to-cart-btn"
                                                        onClick={() => addToCart(service)}
                                                        aria-label={`Add ${service.name} to cart`}
                                                    >
                                                        Add to Cart
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    )}
                                </div>
                            ))
                        )}
                    </div>
                </main>

                {/* Cart Sidebar */}
                <Cart 
                    cartItems={cartItems}
                    onRemoveItem={removeFromCart}
                    onUpdateQuantity={updateQuantity}
                    onViewCart={handleViewCart}
                />
            </div>
        </div>
    );
}